import { RootState } from '@redux/types';

export const mustRefreshAuthenticationSelector = (state: RootState) =>
  state.authentication.mustRefreshAuthentication;
